<template>
  <div ref="box" class="homContent pr">
    <!-- 头部 -->
    <h4 class="f30 titleCon">安全中心客户端下载 <b>Download Client</b></h4>

    <div class="clearfix bodyCon" id="v-step-1">
      <div class="fl tac">
        <div class="btn cp " style="width:200px;margin:20px 0;" @click="downLoadBtn">
          立即下载客户端
        </div>
        <div class="tac">
          <p class="f14 "><span class="tar" style="width:80px;display: inline-block;">版本号：</span><span style="width:100px;display: inline-block;"   class="tal fw"  >{{ getLog.version }}</span></p>
          <p class="f14  "><span  class="tar"  style="width:80px;display: inline-block;">更新日期：</span><span   class="tal fw"  style="width:100px;display: inline-block;">
            {{ getLog.updateTime }}
          </span></p>
        </div>
        <!-- <p class="link">
          <a href="https://www.weihudashi.com/v2/Release/download/%E7%8B%AC%E7%AB%8B%E7%89%88%E6%8C%82%E7%9B%98%E5%90%AF%E5%8A%A8%E9%83%A8%E7%BD%B2%E5%B7%A5%E5%85%B7.rar"
            class="" target="_blank">下载挂盘添加启动项工具</a>
        </p>
        <p class="f14 fw">{{ updateTime }}更新</p> -->
        <div class="logCon tal" v-if="getLog.upDataLog && getLog.upDataLog.length">
          <h3 class="fw f14 tal">更新日志：</h3>
          <Timeline class="lineCon">
            <Timeline-item  v-for="(item,index) in  getLog.upDataLog" :key="index">
                <p class="time fw">{{ item.time }}</p>
                <p class="content" v-for="(list,key) in item.content" :key="key">
                <b>{{key+1 }}.</b> {{ list }}
                </p>
            </Timeline-item>
          </Timeline>
        </div>
      </div>
      <div class="fl rightCon tal">
        <h4 class="fw f16">安全中心客户端是什么？有哪些功能？</h4>
        <p class="f14">
          该客户端是根据用户需求开发的一个单exe客户端，无论网吧是否在使用维护大师产品都可使用，故而取名为安全中心客户端。
        </p>
        <p class="f14">
          该客户端功能包括：软件下发、生效数据采集、防劫持、恶意程序清理功能。
        </p>
        <h4 class="fw f16">如何设置开机启动？</h4>
        <p class="f14">
          下载后可使用各种开机命令/其他软件调用/开机文件夹等方式实现开机启动，程序启动后仅有1个常驻进程，无任何界面，资源占用极低。
        </p>
        <p class="f14">为达到最佳防劫持效果，建议使用挂盘工具添加启动项。</p>
        <h4 class="fw f16">所有网吧都用一个客户端如何区分网吧？</h4>
        <p class="f14">
          该客户端拥有智能的ID管理功能，规则为：如局域网内有维护大师服务端，则自动使用维护大师网吧ID。
        </p>
        <p class="f14">
          如局域网内没有维护大师服务端，客户端运行后可自动注册网吧ID，并将网关MAC作为网吧名。
        </p>
        <!-- <h4 class="fw f16">在哪里开启业务查看收益数据及结算呢？</h4>
        <p class="f14">
          访问
          <a @click="goTo">www.zhuanbar.com</a>或通过维护大师后台右上角赚吧链接免输账号密码打开赚吧，开启或关闭业务后，客户机重启后立即生效，结算及提现请访问赚吧平台了解。
        </p> -->
      </div>
    </div>
    <!-- <div class="loadCon tal pr">
      <h3 class="f40">
        <img src="@/assets/img/icon/u4183.png" alt="" />
        独立版客户端下载
      </h3>
      <h5>【下载说明】</h5>
      <p>1. 此版本客户端暂不支持与维护大师服务端关联</p>
      <p>2. 此版本客户端暂只包含安全中心和赚吧业务通道两大模块</p>
      <p>3. 此版本客户端暂不支持自动更新</p>
      <h5 style="margin-top:40px;">【安装教程】</h5>
      <p>
        1. 使用维护大师通行证登录<a
          href="http://weihudashi.com/?clncac=2020117"
          target="_blank"
          >www.weihudashi.com</a
        >，下载独立版客户端（单exe文件）。
      </p>
      <p>2. 在无盘服务器上，挂载客户机镜像，比如挂载到Z盘。</p>
      <p>
        3. 将exe文件拷贝到Z:\ProgramData\Microsoft\Windows\Start
        Menu\Programs\StartUp
      </p>
      <p>4. 保存挂盘修改，重启客户机生效。</p>
      <div
        class="btn cp tac"
        style="width:200px;margin:20px 0;"
        @click="downLoadBtn"
      >
        立即下载
      </div>
    </div> -->
    <div class="downloadMask pa center pr" v-if="isShowDow">
      <h4 class="clearfix">
        <img src="@/assets/img/icon/u1425.png" class="fl" alt="" />下载客户端
      </h4>
      <b class="pa closeBtn cp" @click="isShowDow = !isShowDow">×</b>
      <div class="inCon">
        <div class="contentCon" v-if="!isDown">
          <img src="@/assets/img/loading/loading.gif" alt="" />
          <p>正在生成客户端，约需60s，请稍后...</p>
        </div>
        <a class="contentCon f14 fw" href="#" @click="downloadFn" v-else>请点击此链接下载客户端！</a>
        <p class="tal checkCon" @click="isCheck = !isCheck">
          <input type="checkbox" class="fl f12" :checked="isCheck" v-model="isCheck"
            style="width:20px;margin-right:4px;" />
          <label for="win10" class="cp">
            我同意<a href="#" @click="lookFn(3)">《维护大师安全中心用户服务协议》</a>
          </label>
        </p>
        <p class="tal checkCon checkCon2" @click="isCheck2 = !isCheck2">
          <input type="checkbox" class="fl f12" :checked="isCheck2" v-model="isCheck2"
            style="width:20px;margin-right:4px;" />
          <label for="win10" class="cp">
            我同意<a href="#" @click="lookFn(2)">《产品隐私政策》</a>
          </label>
        </p>
      </div>
      <div v-if="isShow" class="errorMsg">
        您须先同意用户协议及产品隐私政策才能下载客户端！
      </div>
    </div>
    <Agreement ref="agreementCom" :type="isType" @suerAgree="suerAgree"/>
  </div>
</template>

<script>
// 头部
import { createClient, checkClient } from '@/requests/securityCenter'
import { Encrypt } from '@/utils/secret'
import Agreement from './agreement.vue'
const getLog = require('@/utils/clientLog.json')
export default {

  data () {
    return {
      isDown: false,
      isCheck: false,
      isShow: false,
      isShowTxt: false,
      isShowDow: false,
      timer: null,
      url: '',
      updateTime: '2022-11-01',
      version: '2.2.0.1',
      isCheck2: false,
      getLog: {
        'version': '',
        'updateTime': '',
        'upDataLog': []
      },
      isType:1
    };
  },
  watch: {
    isCheck () {
      if (this.isCheck && this.isCheck2) {
        this.isShow = false;
      }
    },
    isCheck2 () {
      if (this.isCheck && this.isCheck2) {
        this.isShow = false;
      }
    },
  },
  mounted () {
    // setTimeout(() => {
    //   this.isDown = true
    // }, 10);
    // console.log(window.location.host)
    getLog.upDataLog.forEach(element => {
      if (element.content.indexOf(';') != -1) {
        element.content = element.content.split(';')
      }
    });
    this.getLog = getLog
  },
  methods: {
    suerAgree(){
      this.$refs.agreementCom.isShowTxt =false
    },
    lookFn(val) {
      this.$refs.agreementCom.isShowTxt = true
      this.isType = val
    },
    Encrypt,
    goTo () {
      let url = 'http://zhuanbar.com/autoLogin' +
        `?account=${this.$Cookie.getCookie('username')}` +
        '&' +
        `txt=${this.Encrypt(this.$Cookie.getCookie('txt'))}`;
      console.log(url);
      window.open(url, '_blank');
    },
    downLoadBtn () {
      this.createClient();
    },
    downloadFn () {
      if (!this.isCheck || !this.isCheck2) {
        this.isShow = true;
      } else {
        window.open(this.url, '_self');
      }
    },
    async createClient () {
      if (this.url == '') {
        let res = await createClient();
        console.log(res);
        this.isDown = false;
        if (res.code == 200) {
          this.isShowDow = true;
          this.timer = setInterval(() => {
            this.checkClient();
          }, 1000);
        }
      } else {
        this.isShowDow = true;
        this.isDown = true;
      }
    },
    async checkClient () {
      let res = await checkClient();
      if (res.code == 200) {
        this.isDown = true;
        this.url = 'https://www.weihudashi.com/v2/Release/download/' + res.data;
        console.log(this.url);
        clearInterval(this.timer);
      }
    },
  },
  components: { Agreement }
}
</script>
<style lang="scss" scoped>
.homContent {
  padding: 20px;
  background: #eee;
  height: 100%;
  box-sizing: border-box;

  h4 {
    font-size: 30px;
    text-align: left;

    b {
      font-size: 20px;
      color: #666;
    }
  }
}

.loadCon {
  background: #fff;
  padding: 20px;

  h4 {
    line-height: 30px;
    text-align: left;
    font-size: 20px;

    img {
      float: left;
      margin: 6px 10px 0 20px;
    }

    border-bottom: 1px solid #eee;
  }

  h5 {
    margin-top: 10px;
    font-size: 20px;
  }

  p {
    font-size: 14px;
    line-height: 30px;
    margin: 10px 0;
  }
}

.downloadMask {
  background-color: #f3f3f3;
  background: -webkit-linear-gradient(top, #f8f8f8 0, #eeeeee 20%);
  background: -moz-linear-gradient(top, #f8f8f8 0, #eeeeee 20%);
  background: -o-linear-gradient(top, #f8f8f8 0, #eeeeee 20%);
  background: linear-gradient(to bottom, #f8f8f8 0, #eeeeee 20%);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#F8F8F8, endColorstr=#eeeeee, GradientType=0);
  border-radius: 4px;
  box-shadow: 0 0 10px rgba($color: #000000, $alpha: 0.6);
  width: 350px;
  height: 250px;
  padding: 0 10px;
  box-sizing: border-box;
  border: 1px solid rgb(2, 83, 158);
  overflow: hidden;

  h4 {
    font-size: 14px;
    text-align: left;
    text-indent: 10px;
    line-height: 36px;
    background: rgb(2, 83, 158);
    color: #fff;
    width: 358px;
    margin-left: -10px;

    img {
      margin: 10px 0 0 10px;
    }
  }

  &.txtCon {
    h4 {
      width: 670px;
    }
  }

  .closeBtn {
    font-size: 30px;
    right: 10px;
    top: -4px;
    color: #fff;
  }

  .inCon {
    width: 100%;
    background: #fff;
    border: 1px solid rgb(2, 83, 158);
    margin-top: 10px;
    padding: 10px 20px 30px 20px;

    h4,
    h3 {
      background: #fff;
      color: #000000;
      text-align: center;
      font-size: 18px !important;
      font-weight: bold;
    }

    h3 {
      margin: 10px 0;
    }

    h4 {
      font-size: 14px !important;
      text-align: left;
      line-height: 24px !important;
      margin: 10px 0;
    }

    p {
      line-height: 24px;
    }
  }

  a.contentCon {
    line-height: 90px;
    text-decoration: underline;
  }

  .contentCon {
    height: 90px;
    text-indent: 0px;

    img {
      width: 40px;
    }
  }
}

.checkCon {
  text-indent: 0;
  margin-top: 5px;
  &.checkCon2{
    input{margin: 6px 0 0 10px;}
  }
  input {
    margin: 6px 0 0 10px;
  }
}

.errorMsg {
  color: red;
  top: 84%;
  position: absolute;
  text-align: left;
  text-indent: 36px;
}

.txtCon {
  width: 650px;
  height: 508px;

  .inCon {
    overflow: hidden;
    height: 410px;
    overflow-y: auto;
    text-align: left;
  }
}

.f40 {
  font-size: 24px !important;
}

.bodyCon {
  background: #fff;
  width: 100%;
  height: calc(100% - 60px);

  .rightCon {
    width: calc(100% - 322px);
    padding: 40px 20px;
    box-sizing: border-box;

    p {
      margin: 10px 0;
    }
  }

  h4 {
    margin-top: 10px;
  }

  div.fl {
    height: 100%;

    &:nth-child(1) {
      border-right: 1px solid #eee;
      width: 300px;
    }
  }

  .btn {
    font-size: 16px;
    background: #0099cc;
    border-radius: 10px;
    color: #fff;
    display: inline-block;
    width: 200px !important;
    line-height: 60px;
    box-shadow: 0 0 4px rgba($color: #000000, $alpha: 0.6);
    margin: 40px 0 10px !important;

    &:hover {
      opacity: 0.8;

      &:active {
        opacity: 0.9;
      }
    }
  }

  .link {
    color: #2d8cf0;
    font-size: 16px;
    font-weight: bold;
    margin-top: 40px;

    a {
      text-decoration: underline;
    }
  }

  .f16 {
    margin-top: 25px;
    font-size: 20px !important;
  }
}

.titleCon {
  margin-bottom: 20px;
}
.logCon{
  margin-top: 10px;
  padding:  10px;
  border-top: 1px solid #eee;
  .lineCon{
    margin-top: 10px;
  }
  .content{
    margin-top: 4px;
  }
}
</style>
